<script setup lang="ts">
import type { TimelineItemProps } from '@/models/TimelineItem';

withDefaults(defineProps<TimelineItemProps>(), {
	title: undefined,
	subtitle: undefined,
	customClass: undefined,
	direction: 'vertical',
	variant: 'outline',
	color: 'green',
	size: 'md',
});
</script>

<template>
	<div
		class="grid gap-2 group/timeline-item"
		:class="[
			customClass,
			{
				'grid-rows-[24px,1fr]': direction === 'horizontal',
				'grid-cols-[24px,1fr]': direction === 'vertical'
			}
		]"
	>
		<div
			class="flex"
			:class="{
				'flex-row items-center': direction === 'horizontal',
				'flex-col items-center': direction === 'vertical'
			}"
		>
			<div>
				<div
					class="rounded-full"
					:class="{
						'w-5 h-5': size === 'md',
						'w-3 h-3': size === 'sm',
						'border-[3px] !bg-white': variant === 'outline',
						'border-green-300 bg-green-300': color === 'green',
						'border-black bg-black': color === 'black'
					}"
				/>
			</div>
			<div
				:class="{
					'bg-green-300': color === 'green',
					'bg-black': color === 'black',
					'h-[3px] w-full': direction === 'horizontal',
					'w-[3px] h-full': direction === 'vertical'
				}"
			/>
		</div>
		<div
			class="flex w-full gap-6"
			:class="{
				'pr-2': direction === 'horizontal',
				'pb-6 group-last/timeline-item:pb-4': direction === 'vertical'
			}"
		>
			<div>
				<p
					v-if="title"
					class="text-sm leading-tight font-bold mb-1"
					:class="{
						'-mt-[3.5px]': size === 'sm' && direction === 'vertical'
					}"
				>
					{{ title }}
				</p>
				<p
					v-if="subtitle"
					class="text-gray-800 text-xs"
				>
					{{ subtitle }}
				</p>
			</div>
			<slot />
		</div>
	</div>
</template>
